import { ValidationLayer } from "../interface";

export function validateInput(value: string, validation: ValidationLayer[]): string {
    const defaultMessage = "Invalid Input";
    for (const v of validation) {
        if (v.maxLength && value) {
            if (value.length > v.maxLength) {
                return v.message || defaultMessage;
            }
        }
        if (v.minLength && value) {
            if (value.length < v.minLength) {
                return v.message || defaultMessage;
            }
        }
        if (v.regex && value) {
            if (!value.match("^" + v.regex + `$`)) {
                return v.message || defaultMessage;
            }
        }
        if (v.fn) {
            const res = v.fn(value);
            if (res) {
                return res;
            }
        }
    }
    return "";
}
